"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyHeader = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../../shared/core");
var analytics_subjects_1 = require("../../../../analytics-subjects");
var copy_1 = require("../../../../copy");
var EmptyHeader = function (_a) {
    var _b;
    var hasTradMeter = _a.hasTradMeter, hasNonComm = _a.hasNonComm;
    var _c = (0, core_1.useComponents)(), Card = _c.Card, TextLink = _c.TextLink, Icon = _c.Icon, Heading1 = _c.Heading1, P = _c.P;
    var _d = (0, core_1.useCopy)(copy_1.defaultOptions), Copy = _d.Copy, copy = _d.copy;
    var billingHistory = (0, core_1.useLinks)().billingHistory;
    return (react_1.default.createElement(Card, { "data-testid": "billing-header-current-empty" },
        react_1.default.createElement(P, null,
            react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.BILLING_HISTORY_BACK, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) },
                react_1.default.createElement(TextLink, { "data-testid": "back", href: billingHistory() },
                    react_1.default.createElement(Icon, { name: "chevron-left" }),
                    " ",
                    copy('back')))),
        react_1.default.createElement(Heading1, { "data-testid": "billing-period", style: { marginTop: '1.2rem' } },
            react_1.default.createElement(Copy, { copyKey: "emptyCurrentStateTitle" })),
        react_1.default.createElement(P, null, hasTradMeter || hasNonComm ? (react_1.default.createElement(Copy, { copyKey: "emptyCurrentStateSubtitle" })) : (react_1.default.createElement(Copy, { copyKey: "emptyStateSmartMeterSubtitle" })))));
};
exports.EmptyHeader = EmptyHeader;
